(() => {
  'use strict';
  if (window.AWToolsUI?.version) return;

  const normalize = (value = '') => String(value)
    .trim().toLowerCase().normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  const initPlatformPicker = (root) => {
    if (!root || root.dataset.awToolsPlatformPicker === 'true') return;
    const grid = root.querySelector('.aw-configurator__platforms');
    if (!grid) return;
    root.dataset.awToolsPlatformPicker = 'true';

    const buttons = () => Array.from(grid.querySelectorAll('[data-aw-config-platform]'));
    const toolbar = document.createElement('div');
    toolbar.className = 'aw-tools-platform-toolbar';
    toolbar.innerHTML = `
      <label class="aw-tools-platform-search">
        <span class="visually-hidden">Rechercher une plateforme</span>
        <input type="search" autocomplete="off" placeholder="Rechercher une plateforme…" data-aw-tools-platform-search>
      </label>
      <div class="aw-tools-platform-toolbar__meta">
        <span data-aw-tools-platform-count></span>
        <button type="button" data-aw-tools-platform-toggle></button>
      </div>`;
    grid.before(toolbar);

    const input = toolbar.querySelector('[data-aw-tools-platform-search]');
    const count = toolbar.querySelector('[data-aw-tools-platform-count]');
    const toggle = toolbar.querySelector('[data-aw-tools-platform-toggle]');
    let expanded = false;
    const baseLimit = 18;

    const render = () => {
      const list = buttons();
      const query = normalize(input.value);
      const state = (() => {
        try { return JSON.parse(localStorage.getItem(root.dataset.storageKey || 'aw_airsoft_configurator') || '{}') || {}; }
        catch (_) { return {}; }
      })();
      const active = normalize(state.platform || '');
      let visible = 0;
      list.forEach((button, index) => {
        const label = normalize(`${button.dataset.awConfigPlatformLabel || ''} ${button.dataset.awConfigPlatform || ''} ${button.textContent || ''}`);
        const match = !query || label.includes(query);
        const keep = match && (query || expanded || index < baseLimit || normalize(button.dataset.awConfigPlatform) === active);
        button.hidden = !keep;
        if (keep) visible += 1;
      });
      count.textContent = query ? `${visible} résultat${visible > 1 ? 's' : ''} sur ${list.length}` : `${visible} / ${list.length} plateformes affichées`;
      toggle.hidden = Boolean(query) || list.length <= baseLimit;
      toggle.textContent = expanded ? 'Réduire la liste' : `Afficher les ${list.length} plateformes`;
    };

    input.addEventListener('input', render);
    toggle.addEventListener('click', () => { expanded = !expanded; render(); });
    grid.addEventListener('click', (event) => {
      if (event.target.closest('[data-aw-config-platform]')) window.setTimeout(render, 0);
    });
    render();
  };

  const initDirectory = (root) => {
    if (!root || root.dataset.awToolsDirectory === 'true') return;
    const directory = root.querySelector('.aw-compatibility-search__directory');
    if (!directory) return;
    root.dataset.awToolsDirectory = 'true';
    if (root.dataset.modelPage === 'true') {
      directory.hidden = true;
      directory.setAttribute('aria-hidden', 'true');
      return;
    }

    const cards = Array.from(directory.querySelectorAll('[data-aw-directory-card]'));
    if (cards.length <= 12) return;
    directory.classList.add('aw-tools-directory-collapsed');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--secondary aw-tools-directory-toggle';
    button.dataset.awToolsDirectoryToggle = 'true';
    button.textContent = `Afficher les ${cards.length} modèles exacts`;
    directory.appendChild(button);

    const setExpanded = (expanded) => {
      directory.classList.toggle('aw-tools-directory-collapsed', !expanded);
      button.textContent = expanded ? 'Réduire le répertoire' : `Afficher les ${cards.length} modèles exacts`;
    };
    button.addEventListener('click', () => setExpanded(directory.classList.contains('aw-tools-directory-collapsed')));
    directory.querySelectorAll('[data-aw-directory-filter]').forEach((filter) => filter.addEventListener('click', () => {
      const filtered = Boolean(normalize(filter.dataset.awDirectoryFilter || ''));
      window.setTimeout(() => setExpanded(filtered), 0);
    }));
  };

  const initSeoDirectory = () => {
    const shell = document.querySelector('.aw14-model-directory');
    if (!shell || shell.dataset.awToolsSeoDirectory === 'true') return;
    shell.dataset.awToolsSeoDirectory = 'true';

    const platformBlock = shell.querySelector('.aw14-platform-directory');
    const linksRoot = platformBlock?.querySelector('.aw14-platform-directory__links');
    const links = linksRoot ? Array.from(linksRoot.querySelectorAll('a[href]')) : [];
    const modelGrid = shell.querySelector('.aw14-model-directory__grid');
    const modelLinks = modelGrid ? Array.from(modelGrid.querySelectorAll('a[href]')) : [];

    const head = shell.querySelector('.aw14-model-directory__head');
    if (head) {
      const eyebrow = head.querySelector('.aw14-eyebrow');
      const heading = head.querySelector('h2');
      const intro = head.querySelector('p:last-child');
      if (eyebrow) eyebrow.textContent = 'RÉPERTOIRE COMPATIBILITY AW';
      if (heading) heading.textContent = 'Plateformes et modèles Airsoft référencés';
      if (intro) intro.textContent = `${links.length || 65} plateformes et ${modelLinks.length || 38} modèles exacts sont accessibles sans multiplier les blocs visibles. Recherchez une plateforme ou ouvrez le répertoire détaillé des modèles.`;
    }

    if (platformBlock && linksRoot && links.length) {
      const copy = platformBlock.querySelector('.aw14-platform-directory__copy');
      const title = copy?.querySelector('h3');
      if (title) title.textContent = `${links.length} plateformes Compatibility AW`;

      const toolbar = document.createElement('div');
      toolbar.className = 'aw-tools-seo-directory-toolbar';
      toolbar.innerHTML = `
        <label>
          <span class="visually-hidden">Rechercher une plateforme Compatibility AW</span>
          <input type="search" autocomplete="off" placeholder="Rechercher M4, Glock, MP5, Thompson…" data-aw-tools-seo-platform-search>
        </label>
        <div><span data-aw-tools-seo-platform-count></span><button type="button" data-aw-tools-seo-platform-toggle></button></div>`;
      linksRoot.before(toolbar);

      const input = toolbar.querySelector('[data-aw-tools-seo-platform-search]');
      const count = toolbar.querySelector('[data-aw-tools-seo-platform-count]');
      const toggle = toolbar.querySelector('[data-aw-tools-seo-platform-toggle]');
      let expanded = false;
      const baseLimit = 16;

      const renderPlatforms = () => {
        const query = normalize(input.value);
        let visible = 0;
        links.forEach((link, index) => {
          const match = !query || normalize(`${link.textContent || ''} ${link.getAttribute('href') || ''}`).includes(query);
          const show = match && (query || expanded || index < baseLimit);
          link.hidden = !show;
          if (show) visible += 1;
        });
        count.textContent = query ? `${visible} résultat${visible > 1 ? 's' : ''} sur ${links.length}` : `${visible} / ${links.length} plateformes affichées`;
        toggle.hidden = Boolean(query) || links.length <= baseLimit;
        toggle.textContent = expanded ? 'Réduire' : `Afficher les ${links.length} plateformes`;
      };
      input.addEventListener('input', renderPlatforms);
      toggle.addEventListener('click', () => { expanded = !expanded; renderPlatforms(); });
      renderPlatforms();
    }

    if (modelGrid && modelLinks.length) {
      modelGrid.hidden = true;
      modelGrid.dataset.awToolsCollapsed = 'true';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--secondary aw-tools-seo-model-toggle';
      button.textContent = `Afficher les ${modelLinks.length} modèles par familles`;
      modelGrid.before(button);
      button.addEventListener('click', () => {
        const open = modelGrid.hidden;
        modelGrid.hidden = !open;
        modelGrid.dataset.awToolsCollapsed = open ? 'false' : 'true';
        button.textContent = open ? 'Masquer les modèles par familles' : `Afficher les ${modelLinks.length} modèles par familles`;
      });
    }
  };

  const simplifyConfigurator = (root) => {
    if (!root) return;
    const update = () => {
      const count = Number(root.querySelector('[data-aw-config-count]')?.textContent || 0);
      const viewer = root.querySelector('[data-aw-3d-viewer]');
      if (viewer) {
        viewer.hidden = count === 0;
        viewer.dataset.awToolsAutoHidden = count === 0 ? 'true' : 'false';
      }
      const savedCount = Number(root.querySelector('[data-aw-saved-count]')?.textContent || 0);
      const saved = root.querySelector('.aw-configurator__saved');
      if (saved) saved.hidden = savedCount === 0;
    };
    update();
    if (root.dataset.awToolsSimplifyObserved !== 'true' && 'MutationObserver' in window) {
      root.dataset.awToolsSimplifyObserved = 'true';
      let pending = false;
      new MutationObserver(() => {
        if (pending) return;
        pending = true;
        queueMicrotask(() => { pending = false; update(); });
      }).observe(root, { childList: true, subtree: true, characterData: true });
    }
  };


  const updateExactCoverage = () => {
    const root = document.querySelector('[data-aw-compatibility-search]');
    if (!root || root.dataset.modelPage !== 'true') return;
    const record = window.AWToolsPersistence?.currentRecord?.();
    if (!record?.handle) return;
    const modelNode = Array.from(document.querySelectorAll('[data-aw-tool-model]'))
      .find((node) => normalize(node.dataset.handle || '') === normalize(record.handle));
    if (!modelNode) return;
    const productIds = String(modelNode.dataset.productIds || '').split(',').map((value) => value.trim()).filter(Boolean);
    const exactCount = productIds.length;
    root.dataset.awToolsExactProductCount = String(exactCount);

    const identity = root.querySelector('.aw-compatibility-search__identity');
    if (identity) {
      let note = identity.querySelector('[data-aw-tools-exact-coverage]');
      if (!note) {
        note = document.createElement('p');
        note.className = 'aw-tools-exact-coverage';
        note.dataset.awToolsExactCoverage = 'true';
        note.setAttribute('role', 'status');
        identity.appendChild(note);
      }
      note.textContent = exactCount
        ? `Couverture modèle exact : ${exactCount} produit${exactCount > 1 ? 's' : ''} directement relié${exactCount > 1 ? 's' : ''} et visible${exactCount > 1 ? 's' : ''} actuellement. Les autres résultats restent des correspondances de plateforme ou de profil à contrôler.`
        : 'Couverture modèle exact : aucun produit exact n’est actuellement visible dans la boutique pour ce modèle. Les résultats ci-dessous sont des correspondances de plateforme ou de profil à contrôler avant commande ou montage.';
    }

    Array.from(root.querySelectorAll('span,strong,p')).forEach((element) => {
      const text = String(element.textContent || '').trim();
      const match = text.match(/^(\d+)\s+correspondances catalogue$/i);
      if (!match) return;
      element.textContent = exactCount
        ? `${match[1]} correspondances catalogue · ${exactCount} lien${exactCount > 1 ? 's' : ''} exact${exactCount > 1 ? 's' : ''}`
        : `${match[1]} correspondances de plateforme / profil`;
      element.dataset.awToolsCoverageSummary = 'true';
    });
  };

  const updateCounts = () => {
    const compatibility = document.querySelector('[data-aw-compatibility-search]');
    if (compatibility) {
      const manual = compatibility.querySelector('[data-aw-manual-platform]');
      const platformCount = manual ? Array.from(manual.options).filter((option) => option.value).length : 0;
      const directory = compatibility.querySelector('.aw-compatibility-search__directory');
      const modelCount = directory?.querySelectorAll('[data-aw-directory-card]').length || 0;
      compatibility.dataset.awToolsPlatformCount = String(platformCount);
      compatibility.dataset.awToolsModelCount = String(modelCount);
      const intro = directory?.querySelector('.aw-compatibility-search__directory-intro');
      if (intro && platformCount) intro.textContent = `${modelCount} modèles exacts disposent déjà d’une fiche dédiée. La recherche manuelle couvre ${platformCount} plateformes AW.`;
    }
  };

  const init = (scope = document) => {
    const configurators = [];
    if (scope.matches?.('[data-aw-configurator]')) configurators.push(scope);
    scope.querySelectorAll?.('[data-aw-configurator]').forEach((root) => configurators.push(root));
    configurators.forEach((root) => {
      initPlatformPicker(root);
      simplifyConfigurator(root);
    });

    const compatibilities = [];
    if (scope.matches?.('[data-aw-compatibility-search]')) compatibilities.push(scope);
    scope.querySelectorAll?.('[data-aw-compatibility-search]').forEach((root) => compatibilities.push(root));
    compatibilities.forEach((root) => { initDirectory(root); updateExactCoverage(); });
    initSeoDirectory();
    updateCounts();
  };

  window.AWToolsUI = { version: '1.2.1', init, updateCounts, updateExactCoverage, initSeoDirectory };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  window.addEventListener('aw:context-changed', () => queueMicrotask(() => { updateCounts(); updateExactCoverage(); }));
})();